/* eslint-disable no-restricted-syntax */
/* eslint-disable no-await-in-loop */

import React, { useState, useRef, useEffect } from "react";

import {
    Box,
    Divider,
    TextField,
    Grid,
    Button,
    IconButton,
    Card,
    styled,
    FormHelperText,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    Tooltip,
    Typography,
    ButtonGroup,
    Menu,
    Input,
    InputAdornment,
    Chip
} from '@mui/material';

import dayjs from "dayjs";
import XLSX from 'xlsx';

import {
    DataGrid,
    GridColDef,
    GridToolbar,
    GridToolbarContainer,
    GridToolbarExport,
    GridToolbarQuickFilter,
    GridCellParams,
    useGridApiContext,
    useGridApiRef,
    GridCellEditStopReasons
} from '@mui/x-data-grid';

import { grey, orange } from "@mui/material/colors";

import PopupState, { bindTrigger, bindMenu } from 'material-ui-popup-state';

import { useNavigate, useParams } from 'react-router-dom';

import { useFormik } from 'formik';

import { useAppContextFeatures } from "../../../context/AppContext";
import { useAuthAccess } from "../../../hooks/useAuthAccess";

import CommonSectionHeader from "../../common/CommonSectionHeader";
import CommonBreadcumbs from '../../common/CommonBreadcumbs';
import CommonRestricted from "../../common/CommonRestricted";
import DatePickerComponent from "../../common/DatePickerComponent";
import LocationSelector from "../../selector/LocationSelector";
import { CommonIcons, icons } from "../../common/CommonIcons";
import SearchItems from "../../dialog/SearchItems";

import { useSystemPrompt } from "../../../hooks/useSystemPrompt";
import { useSystemRoutes, routeTypes } from "../../../hooks/useSystemRoutes";
import { useSystemHead, headTitles } from '../../../hooks/useSystemHead';
import { useTranslations } from '../../../hooks/useTranslations';

import { useDocuments, documentTypes, targetTypes } from "../../../hooks/api/useDocuments";
import { useInventories, inventoriesTypes } from "../../../hooks/api/useInventories"
import { usePermissions, scopeIds, scopeTypes, functionTypes } from "../../../hooks/usePermissions";
// import { useStateStockTake } from "../../../hooks/state/loadFrom/documents/useStateStockTake";

import { validationSchema, initialValues, initialRowValues } from "../../../schema/documents/stockTakeSchema";

// import {
//     loadFromDocumentTypes,
//     LoadFromDocuments
// } from "../../dialog/LoadFromDocuments";

import { CommonLoader } from "../../common/CommonLoader"

const StyledCard = styled(Card)(({ theme }) => ({
    padding: theme.spacing(2)
}));

const StyledIcon = styled(Box)({
    width: 20,
    height: 20,
    textAlign: 'center',
    alignItems: 'center',
    justifyContent: 'center',
});

const VisuallyHiddenInput = styled(Input)({
    clip: 'rect(0 0 0 0)',
    clipPath: 'inset(50%)',
    height: 1,
    overflow: 'hidden',
    position: 'absolute',
    bottom: 0,
    left: 0,
    whiteSpace: 'nowrap',
    width: 1,
});

const StyledDataGrid = styled(DataGrid)(({ theme }) => ({
    border: 1,
    '& .super-app-theme--header': {
        // backgroundColor: 'rgba(255, 7, 0, 0.55)',
        backgroundColor: orange[500],
        // color: grey[100]
    },
    '& .super-app-theme--cell': {
        // backgroundColor: 'rgba(255, 7, 0, 0.55)',
        backgroundColor: orange[100]
    },
}));

let _excelHeaders = {
    no: { id: 'no', display: '#', indexNo: 0 },
    itemId: { id: 'itemId', display: 'ITEM ID', indexNo: 1 },
    itemName: { id: 'itemName', display: 'ITEM NAME', indexNo: 2 },
    code: { id: 'code', display: 'CODE', indexNo: 3 },
    model: { id: 'model', display: 'MODEL', indexNo: 4 },
    uomId: { id: 'uomId', display: 'UOM ID', indexNo: 5 },
    uom: { id: 'uom', display: 'UOM', indexNo: 6 },
    inStockQty: { id: 'inStockQty', display: 'INSTOCK QTY', indexNo: 7 },
    pendingInboundQty: { id: 'pendingInboundQty', display: 'PENDING INBOUND QTY', indexNo: 8 },
    transferInTransitQty: { id: 'transferInTransitQty', display: 'TRANSFER INTRANSIT QTY', indexNo: 9 },
    stockTakeQty: { id: 'stockTakeQty', display: 'STOCKTAKE QTY', indexNo: 10 }
}

let _maxRowsAllowed = 100

function CustomToolbar({ t, formik, selectedIds, handleRemoveRows, handleSearchItem, handleFileUpload, handleDownloadDataset }) {

    const { values } = formik

    // calculate the summary
    let totalCount = values.rows.length
    let unFilledUp = values.rows.filter(i => i.qty !== undefined && i.qty !== "" && i.qty !== null)
    let totalQty = values.rows.reduce((total, i) => {
        if (i.qty !== undefined && i.qty !== "" && i.qty !== null) {
            total += parseInt(i.qty, 10)
        }
        return total
    }, 0)

    return (
        <GridToolbarContainer
        // sx={{
        //     display: "flex",
        //     flexDirection: "row",
        //     justifyContent: "space-between",
        //     alignItems: "center",
        //     // backgroundColor: 'red'
        // }}
        >
            <Grid container spacing={1}>
                <Grid item xs={12} sm={12} md={4}>
                    {/* <CommonSectionHeader
                        title={t(`items`)}
                        subTitle={t(`detailInformationAboutTheItemsInvolved`)}
                    /> */}

                    <PopupState
                        variant="popover"
                        popupId="dataGridToolbar"
                    >
                        {(popupState) => (
                            <>

                                <Button
                                    {...bindTrigger(popupState)}
                                    size="medium"
                                >
                                    {
                                        (selectedIds.length > 0) &&
                                        <Chip
                                            label={`${selectedIds.length}`}
                                        />
                                    }
                                    <CommonIcons name={icons.morevert} />
                                </Button>

                                {/* <Button
                                    size="medium"
                                    variant="contained"
                                    sx={{
                                        ml: 1
                                    }}
                                > */}
                                <Button
                                    component="label"
                                    role={undefined}
                                    variant="contained"
                                    tabIndex={-1}
                                    color={"primary"}
                                    size="medium"
                                    startIcon={<CommonIcons name={icons.import} />}
                                >
                                    {/* <CommonIcons name={icons.import} /> */}
                                    <Typography sx={{ ml: 1 }}>
                                        {`${t("importDatasets")}`}
                                    </Typography>

                                    <VisuallyHiddenInput
                                        type="file"
                                        onChange={handleFileUpload}
                                        inputProps={{ accept: ".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel" }}
                                    />

                                </Button>

                                <Button
                                    size="medium"
                                    variant="text"

                                    sx={{
                                        ml: 1
                                    }}
                                    onClick={handleDownloadDataset}
                                >
                                    <CommonIcons name={icons.download} />
                                    <Typography sx={{ ml: 1 }}>
                                        {`${t("downloadFormat")}`}
                                    </Typography>
                                </Button>

                                <Menu {...bindMenu(popupState)}>

                                    <MenuItem
                                        disabled={
                                            selectedIds.length <= 0
                                        }
                                        sx={{
                                            // m: 1,
                                        }}
                                        onClick={() => {
                                            popupState.close();
                                            handleRemoveRows({ selectedIds })
                                        }}
                                    >
                                        <CommonIcons name={icons.remove} />
                                        <Typography
                                            sx={{
                                                // textTransform: 'lowercase'
                                                ml: 1
                                            }}
                                        >
                                            {`${t("deleteSelected")}`}
                                        </Typography>
                                    </MenuItem>

                                </Menu>

                            </>
                        )}
                    </PopupState>

                </Grid>
                <Grid item xs={12} sm={12} md={4} display={"flex"} alignItems={"center"} justifyContent={"flex-end"} flexDirection={"row"}>
                    <GridToolbarQuickFilter
                        fullWidth
                        size="small"
                        variant="outlined"
                        label={`${t("Search Keyword")}`}
                        sx={{
                            flex: 1
                        }}
                    />
                </Grid>
                <Grid item xs={12} sm={12} md={4} textAlign={"right"}>
                    <Grid container columnSpacing={1}>
                        <Grid item xs={12} sm={12} md={4}>
                            <TextField
                                disabled
                                fullWidth
                                size="small"
                                label={`${t("importedRows")}`}
                                // value={`${unFilledUp.length}`}
                                value={totalCount}
                                InputProps={{
                                    style: {
                                        paddingRight: 0
                                    },
                                    endAdornment: (
                                        <InputAdornment position="end">
                                            <Box
                                                display={"flex"}
                                                flexDirection={"row"}
                                                justifyContent={"space-between"}
                                                alignItems={"center"}
                                            >
                                                <Typography> / {_maxRowsAllowed}</Typography>
                                                <Tooltip title={`${t("maxRowsAllowed")}: ${_maxRowsAllowed}`}>
                                                    <IconButton>
                                                        <CommonIcons name={icons.info} />
                                                    </IconButton>
                                                </Tooltip>
                                            </Box>
                                        </InputAdornment>
                                    ),
                                }}
                            />
                        </Grid>
                        <Grid item xs={12} sm={12} md={4}>
                            <TextField
                                fullWidth
                                disabled
                                size="small"
                                label={`${t("totalStockTakeQty")}`}
                                value={`${totalQty}`}
                            />
                        </Grid>
                        <Grid item xs={12} sm={12} md={4}>
                            <Button
                                fullWidth
                                component="label"
                                role={undefined}
                                variant="contained"
                                tabIndex={-1}
                                color={"primary"}
                                size="medium"
                                startIcon={<CommonIcons name={icons.plus} />}
                                onClick={handleSearchItem}
                            >
                                <Typography
                                    sx={{
                                        // mr: 1
                                    }}
                                >
                                    {`${t("addItem")}`}
                                </Typography>
                            </Button>
                        </Grid>
                    </Grid>


                    {/* <Typography
                        sx={{
                            color: grey[500]
                        }}
                    >
                        {`${unFilledUp.length}/${totalCount}`}
                    </Typography> */}
                </Grid>
            </Grid>
            {/* <GridToolbarExport /> */}

        </GridToolbarContainer>
    );
}

const RenderFormLocation = ({ t, formik, availableLocations, handleResetLocation }) => {

    const { values, errors, touched, andleChange, setFieldValue, handleChange } = formik

    let locationsTo = [];

    // get the current available location To 
    if (values.locationId)
        locationsTo = availableLocations.filter(i => i.id !== values.locationId)

    return (
        <StyledCard>
            <Grid container spacing={0.5}>
                <Grid item xs={12} sm={12} md={12} textAlign={"left"}>

                    <CommonSectionHeader
                        title={t(`location`)}
                        subTitle={t(`relatedWarehouseLocationToProcess`)}
                    />
                </Grid>
                <Grid item xs={12} sm={12} md={12}>
                    <TextField
                        disabled
                        margin="dense"
                        size="small"
                        fullWidth
                        name={"locationId"}
                        label={t("location")}
                        type="text"
                        variant="outlined"
                        value={values.locationName}
                        error={touched.locationId && Boolean(errors.locationId)}
                        helperText={touched.locationId && errors.locationId}
                    />
                </Grid>
                {/* <Grid item md={1.5}>
                    <IconButton
                        color="primary"
                        sx={{
                            // pt: 0
                        }}
                        onClick={handleResetLocation}
                    >
                        <StyledIcon
                            sx={{
                                width: 25,
                                height: 25,
                                m: 0,
                                p: 0
                            }}
                        >
                            <CommonIcons name={icons.edit} />
                        </StyledIcon>
                    </IconButton>
                </Grid> */}

            </Grid>
        </StyledCard>
    )
}

// const RenderFormImportExport = ({ t, formik, handleDownloadDataset }) => {

//     // const { values, errors, touched, andleChange, setFieldValue, handleChange } = formik

//     return (
//         <StyledCard>

//             <Box
//                 display={"flex"}
//                 justifyContent={"space-between"}
//                 alignItems={"center"}
//                 flexDirection={"row"}
//             >
//                 <Box>
//                     <CommonSectionHeader
//                         title={t(`importAndExport`)}
//                         subTitle={t(`importExcelDatasetsOrDownloadLatestItems`)}
//                     />
//                 </Box>
//                 <Box>
//                     <PopupState
//                         variant="popover"
//                         popupId="dataGridToolbar"
//                     >
//                         {(popupState) => (
//                             <>
//                                 <ButtonGroup variant="outline">
//                                     {/* <Button
//                                         variant="contained"
//                                         color={"info"}
//                                         size="medium"
//                                     >
//                                         <Typography
//                                             sx={{
//                                                 // mr: 1
//                                             }}
//                                         >
//                                             {`${t("importDatasets")}`}
//                                         </Typography>
//                                     </Button> */}

//                                     {/* <Button
//                                         component="label"
//                                         role={undefined}
//                                         variant="contained"
//                                         tabIndex={-1}
//                                         color={"info"}
//                                         size="medium"
//                                         startIcon={<CommonIcons name={icons.import} />}
//                                     >
//                                         <Typography
//                                             sx={{
//                                                 // mr: 1
//                                             }}
//                                         >
//                                             {`${t("importDatasets")}`}
//                                         </Typography>
//                                         <VisuallyHiddenInput
//                                             type="file"
//                                             onChange={handleFileUpload}
//                                             inputProps={{ accept: ".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel" }}
//                                         />
//                                     </Button> */}

//                                     <Button
//                                         {...bindTrigger(popupState)}
//                                         variant="contained"
//                                         color={"primary"}
//                                         size="medium"
//                                     // variant="outlined"
//                                     // aria-controls={open ? 'split-button-menu' : undefined}
//                                     // aria-expanded={open ? 'true' : undefined}
//                                     // aria-label="select merge strategy"
//                                     // aria-haspopup="menu"
//                                     // onClick={handleToggle}
//                                     >
//                                         {/* <MoreVertIcon /> */}
//                                         {/* <Typography
//                                             sx={{
//                                                 mr: 1
//                                             }}
//                                         >
//                                             {`${t("actions")}`}
//                                         </Typography> */}
//                                         <CommonIcons name={icons.morevert} />
//                                     </Button>
//                                 </ButtonGroup>

//                                 <Menu {...bindMenu(popupState)}>

//                                     {/* <MenuItem
//                                         sx={{
//                                             // m: 1,
//                                         }}
//                                         onClick={() => {
//                                             popupState.close();
//                                             handleDownloadDataset()
//                                         }}
//                                     >
//                                         <CommonIcons name={icons.download} />
//                                         <Typography
//                                             sx={{
//                                                 // textTransform: 'lowercase'
//                                                 ml: 1
//                                             }}
//                                         >
//                                             {`${t("downloadImportFormatExcel")}`}
//                                         </Typography>
//                                     </MenuItem> */}

//                                     {/* <Divider sx={{ borderStyle: 'dashed' }} /> */}

//                                     {/* <MenuItem
//                                         sx={{
//                                             // m: 1,
//                                             fontSize: '0.9rem'
//                                         }}
//                                     // onClick={() => {
//                                     //     popupState.close();

//                                     //     actionOnClickRemove();

//                                     // }}
//                                     >
//                                         <CommonIcons name={icons.chevronDown} />
//                                         <Typography
//                                             sx={{
//                                                 // textTransform: 'lowercase'
//                                                 ml: 1
//                                             }}
//                                         >
//                                             {`${t("importDataset")}`}
//                                         </Typography>
//                                     </MenuItem> */}

//                                 </Menu>

//                             </>
//                         )}
//                     </PopupState>
//                 </Box>
//             </Box>

//         </StyledCard>
//     )
// }

const RenderFormDocument = ({ t, formik }) => {

    const { values, errors, touched, andleChange, setFieldValue, handleChange } = formik

    return (
        <StyledCard>
            <Grid container spacing={0.5}>
                <Grid item xs={12} sm={12} md={12} textAlign={"left"}>

                    <CommonSectionHeader
                        title={t(`document`)}
                        subTitle={t(`basicInformationAboutTheDocument`)}
                    />

                </Grid>
                <Grid item xs={12} sm={12} md={12} sx={{ mt: 2 }}>
                    <Grid container spacing={0.5}>

                        <Grid item xs={12} sm={12} md={12} textAlign={"left"}>

                            <DatePickerComponent
                                config={{
                                    name: "documentDate",
                                    label: t("documentDate")
                                }}
                                formik={{
                                    values,
                                    errors,
                                    touched,
                                    handleChange,
                                    setFieldValue
                                }}
                            />

                        </Grid>

                        <Grid item xs={12} sm={12} md={12}>
                            <TextField
                                margin="dense"
                                size="small"
                                fullWidth
                                name={"remark"}
                                label={t("remark")}
                                type="text"
                                variant="outlined"
                                multiline
                                rows={3}
                                value={values.remark}
                                onChange={handleChange}
                                error={touched.remark && Boolean(errors.remark)}
                                helperText={touched.remark && errors.remark}
                            />
                        </Grid>

                    </Grid>
                </Grid>
            </Grid>
        </StyledCard>
    )
}

const RenderForm = ({
    t,
    datagridRef,
    formik,
    selectedIds,
    datagridColumns,
    dataInventory,
    availableLocations,
    handleSearchItem,
    handleResetLocation,
    handleDownloadDataset,
    handleFileUpload,
    onCellEditStop,
    handleRowSelectionModelChange,
    handleRemoveRows,
}) => {

    const { handleSubmit, values } = formik

    // sort the rows append the no
    const _currentRows = values?.rows
    const rows = []

    _currentRows.forEach((i, index) => {
        rows.push({
            ...i,
            no: (index + 1)
        })
    })

    return (
        <form onSubmit={handleSubmit}>

            <Grid container spacing={1}>

                <Grid item xs={12} sm={12} md={6} textAlign={"left"}>
                    <RenderFormDocument
                        t={t}
                        formik={formik}
                    />
                </Grid>


                <Grid item xs={12} sm={12} md={6} textAlign={"left"}>

                    <RenderFormLocation
                        t={t}
                        formik={formik}
                        availableLocations={availableLocations}
                        handleResetLocation={handleResetLocation}
                    />

                    {/* <Box
                        sx={{
                            mt: 1
                        }}
                    >
                        <RenderFormImportExport
                            t={t}
                            formik={formik}
                            handleDownloadDataset={handleDownloadDataset}
                        // handleFileUpload={handleFileUpload}
                        />
                    </Box> */}

                </Grid>

            </Grid>
            <StyledCard sx={{ mt: 1 }}>
                <Grid container rowSpacing={0}>
                    {/* <Grid item xs={12} sm={12} md={12} textAlign={"left"}>

                        <CommonSectionHeader
                            title={t(`items`)}
                            subTitle={t(`detailInformationAboutTheItemsInvolved`)}
                        />

                    </Grid> */}


                    <Grid item xs={12} sm={12} md={12} textAlign={"left"}>

                        {/* {
                            values.rows.length <= 0 ?
                                (
                                    <Box
                                        sx={{
                                            minHeight: 300,
                                            display: "flex",
                                            justifyContent: "center",
                                            alignItems: "center"
                                        }}
                                    >
                                        <Typography
                                            sx={{ color: grey[500] }}
                                        >
                                            {t("noItemHasAdded")}
                                        </Typography>
                                    </Box>
                                )
                                :
                                ( */}

                        <Box
                            sx={{
                                height: 500
                            }}
                        >
                            <StyledDataGrid
                                apiRef={datagridRef}
                                getRowId={(row) => row?.itemId}
                                sx={{
                                    // borderColor: grey[300],
                                    // borderStyle: 'solid',
                                    // borderWidth: 1,
                                    // p: 0.5
                                    // height: '100%'
                                }}
                                rows={rows}
                                columns={datagridColumns}
                                header
                                initialState={{
                                    pagination: {
                                        paginationModel: { page: 0, pageSize: 30 },
                                    },
                                }}
                                pageSizeOptions={[30, 50, 100]}
                                checkboxSelection

                                disableToolbarButton
                                disableColumnFilter
                                disableColumnSelector
                                disableDensitySelector
                                disableColumnMenu={Boolean(true)}
                                disableRowSelectionOnClick

                                density="compact"

                                // slots={{ toolbar: GridToolbar }}
                                slots={{
                                    // noRowsOverlay: () => <Box sx={{ height: 300 }}><Typography>No Records</Typography></Box>,
                                    toolbar: () => CustomToolbar({
                                        t,
                                        formik,
                                        selectedIds,
                                        handleRemoveRows,
                                        handleSearchItem,
                                        handleFileUpload,
                                        handleDownloadDataset
                                    })
                                }}

                                onCellEditStop={onCellEditStop}

                                // onCellModesModelChange={(params, details) => {
                                //     console.log('praops', params, details)
                                // }}

                                // slotProps={{
                                //     toolbar: {
                                //         showQuickFilter: true,
                                //         printOptions: { disableToolbarButton: true }
                                //     },
                                // }}
                                // disableRowSelectionOnClick
                                rowSelectionModel={selectedIds}
                                onRowSelectionModelChange={handleRowSelectionModelChange}
                            />

                        </Box>
                        {/* )
                        } */}
                    </Grid>

                </Grid>
            </StyledCard>
            <Grid container spacing={1} sx={{ pl: 2, pr: 2 }}>
                <Grid item md={12} textAlign={"right"}>
                    <Button
                        type="button"
                        variant="contained"
                        sx={{
                            mt: 3,
                            mb: 2
                        }}
                        onClick={() => formik.submitForm()}
                    >
                        {t('saveChanges')}
                    </Button>
                </Grid>
            </Grid>

        </form>
    )
}

const RenderAll = ({
    t,
    datagridRef,
    formik,
    selectedIds,
    // allowMainForm = false,
    datagridColumns,
    dataInventory,
    availableLocations,
    handleSearchItem,
    handleLocationOnNext,
    handleResetLocation,
    handleDownloadDataset,
    handleFileUpload,
    onCellEditStop,
    handleRowSelectionModelChange,
    handleRemoveRows
}) => {

    // return allowMainForm === true ?

    const { values } = formik

    if (!values) return <></>

    return (
        <RenderForm
            t={t}
            datagridRef={datagridRef}
            formik={formik}
            selectedIds={selectedIds}
            datagridColumns={datagridColumns}
            dataInventory={dataInventory}
            availableLocations={availableLocations}
            handleSearchItem={handleSearchItem}
            handleResetLocation={handleResetLocation}
            handleDownloadDataset={handleDownloadDataset}
            handleFileUpload={handleFileUpload}
            onCellEditStop={onCellEditStop}
            handleRowSelectionModelChange={handleRowSelectionModelChange}
            handleRemoveRows={handleRemoveRows}
        />
    )
    // :
    // (
    //     <LocationSelector
    //         config={{
    //             title: t("selectOnly1Location"),
    //             description: t("youHaveToSelectAnyoneOfTheWarehouseLocationToProceed")
    //         }}
    //         maxSelect={1}
    //         handleOnNext={handleLocationOnNext}
    //     />
    // )
}

const RenderCommonLoader = ({
    title,
    loaderOpen,
    handleCloseLoader,
    dataDownloadInventory,
    dataDownloadInventoryCount
}) => {

    let _title = title
    let _CircularProgressProps = {}
    let _middleLabel = ``
    let _bottomLabel = ``

    let currentDataDownloadInventoryLength = dataDownloadInventory.length

    // console.log('dataDownloadInventoryCount', dataDownloadInventoryCount)

    if (
        dataDownloadInventoryCount !== -1 &&
        currentDataDownloadInventoryLength === dataDownloadInventoryCount
    ) {
        _CircularProgressProps = {
            variant: "determinate",
            value: 100
        }
    }
    // console.log('dataDownloadInventory', currentDataDownloadInventoryLength, dataDownloadInventoryCount)

    if (currentDataDownloadInventoryLength === 0) {
        _middleLabel = `0%`
    } else {
        _middleLabel = `${Math.round(parseInt((currentDataDownloadInventoryLength / dataDownloadInventoryCount * 100), 10))}%`
        _bottomLabel = `${currentDataDownloadInventoryLength} / ${dataDownloadInventoryCount}`
    }

    return (
        <CommonLoader
            open={loaderOpen}
            handleClose={handleCloseLoader}
            title={_title}
            CircularProgressProps={_CircularProgressProps}
            middleLabel={_middleLabel}
            bottomLabel={_bottomLabel}
        />
    )
}

export default function UpdateStockTake({
    routeType
}) {
    const { t } = useTranslations({ ns: ["common", "@document"] })

    const { id } = useParams();

    const datagridRef = useGridApiRef();

    const navigate = useNavigate()

    const { getAvailableLocations } = useAuthAccess();
    const { getLocationIds, setLocationIds } = useAppContextFeatures();

    const { promptMessage } = useSystemPrompt();
    const { getRoute } = useSystemRoutes(routeType)
    const { getHtmlHead } = useSystemHead(routeType)
    const { isPermissionAllow } = usePermissions(routeType, scopeIds.document.id, scopeTypes.document.stockTake.id)

    const { setSystemLoading } = useAppContextFeatures();
    const { isLoading, get, update, filterOperatorTypes } = useDocuments({
        documentType: documentTypes.stockTake,
        targetType: targetTypes.stockTake
    })
    const { list: listInventories } = useInventories({ inventoriesType: inventoriesTypes.inventory })

    const [dataInventory, setDataInventory] = useState([])
    // for download dataset purpose
    const [dataDownloadInventory, setDataDownloadInventory] = useState([])
    const [dataDownloadInventoryCount, setDataDownloadInventoryCount] = useState(-1)

    const [selectedIds, setSelectedIds] = useState([])

    const [savedValues, setSavedValues] = useState()

    // const { updateFormikStates, getFormikDependencyStates } = useStateStockTake()

    const availableLocations = getAvailableLocations();

    const [loaderOpen, setLoaderOpen] = useState(false)
    const [searchOpen, setSearchOpen] = useState(false)

    const handleCloseLoader = () => {
        setLoaderOpen(false)
    }

    const loadData = async (id) => {

        setSystemLoading(true)

        try {

            const { data } = await get({ id })
            const { document, items } = data;

            // create rows
            const rows = items.map((i) => {
                return {
                    docItemId: i?.id,
                    itemId: i?.item_id,
                    name: i?.item_name,
                    code: i?.code,
                    description: i?.description,
                    qty: parseFloat(i?.qty),
                    uomName: i?.uom_name,
                    uomId: i?.uom_id,
                    price: i?.uom_price
                }
            })

            setSavedValues({
                locationId: document?.location_id,
                locationName: document?.location_name,
                documentNumber: document?.doc_number,
                documentDate: dayjs(document?.doc_date),
                remark: document?.doc_remark ? document.doc_remark : "",
                rows,
            })

        } catch (error) {
            promptMessage(false, `${error?.message}`)
        }

        setSystemLoading(false)

    }

    async function sequentialCall({ locationIds, itemsIds, pageArray, limit }) {

        let allData = []

        for (let i of pageArray) {

            let skip = (limit * i)

            let { inventories } = await fetchInventories({ locationIds, itemsIds, limit, skip })
            // console.log('runnning ', i, inventories, skip)

            allData = [...allData, ...inventories]

            setDataDownloadInventory(prev =>
                [...prev, ...inventories]
            )

        }

        // console.log('finish all');

        return allData

    };

    const fetchAllInventories = async ({ locationIds, itemsIds = [], pageNo = 0 }) => {

        // setSystemLoading(true)
        setDataDownloadInventory([])

        setLoaderOpen(true)

        // fetch the first attempt
        let limit = 100
        let skip = 0
        let {
            total: totalRecords,
            // nofilter_total: totalRecords,
            inventories: firstResult
        } = await fetchInventories({ locationIds, itemsIds, limit, skip })

        let firstResultLength = firstResult.length

        setDataDownloadInventory(firstResult)
        setDataDownloadInventoryCount(totalRecords)

        // console.log('firstResult', firstResult, firstResultLength, totalRecords)

        let sequentialData = []

        if (firstResultLength === limit) {

            let balanceRecords = totalRecords - limit

            let totalPageNo = parseInt(balanceRecords / limit, 10)
            let lastPageRecordLength = balanceRecords - (totalPageNo * limit)

            if (lastPageRecordLength > 0) {
                totalPageNo += 1
            }

            let pageArray = []

            for (let i = 0; i < totalPageNo; i += 1) {
                pageArray.push((i + 1));
            }

            console.log('pageArray', pageArray)

            sequentialData = await sequentialCall({
                locationIds,
                itemsIds,
                pageArray,
                limit,
            })
        }

        generateExcelDownload({
            allData: [...firstResult, ...sequentialData]
        })
    }

    const fetchInventories = async ({ locationIds, itemIds = [], limit, skip }) => {

        try {

            let filterValues = [
                {
                    name: "location_id",
                    operator: filterOperatorTypes.anyOf,
                    value: JSON.stringify(locationIds)
                }
            ]

            if (itemIds.length > 0) {
                filterValues.push({
                    name: "id",
                    operator: filterOperatorTypes.anyOf,
                    value: JSON.stringify(itemIds)
                })
            }

            let props = {
                limit,
                skip,
                sortInfo: {
                    id: "id",
                    dir: -1,
                },
                filterValue: filterValues
            }

            props.dataTypes = ["group_location", "pending_inbound", "transfer_in_transit"]

            let { data } = await listInventories(props);

            return data

        } catch (error) {
            promptMessage(false, `${error.message}`)
        }

        return true

    }

    const onSubmit = async (currentValues) => {

        setSystemLoading(true)

        try {

            const document = {
                doc_date: currentValues.documentDate.format("YYYY-MM-DD"),
                doc_remark: currentValues.remark,
            }

            const props = {
                location_id: currentValues.locationId,
            }

            let items = [];

            currentValues.rows.map(item => {
                items.push({
                    id: item?.itemId,
                    doc_item_id: item?.docItemId,
                    code: item?.code,
                    name: item?.name,
                    description: item?.description,
                    qty: item?.qty,
                    uom_lbl: item?.uomName,
                    uom: item?.uomId,
                    price: item?.price
                })
                return false;
            })

            let data = {
                document,
                props,
                items,
                // ...getFormikDependencyStates({ values })
            }

            const response = await update({ id, data });

            promptMessage(true, `${response?.message}`)

            navigate(getRoute("documents/stockTakes"))

        } catch (error) {
            promptMessage(false, `Action Failed (${error?.message})`)
        }

        setSystemLoading(false)

    }

    const formik = useFormik({
        initialValues: savedValues,
        validationSchema,
        enableReinitialize: true,
        onSubmit
    });

    const { handleSubmit, handleChange, values, errors, touched, setFieldValue, } = formik;

    useEffect(() => {

        loadData(id)

    }, [])

    const getDatagridColumns = () => {

        return [
            {
                field: 'no',
                headerName: 'No.',
                // headerClassName: 'my-super-theme--naming-group',
                width: 90
            },
            {
                field: `itemId`,
                headerName: t("itemId"),
                headerAlign: 'center',
                align: 'center',
                // headerClassName: 'my-super-theme--naming-group',
                width: 90,
                // renderCell: (params) => {
                //     // console.log('params', params)
                //     return `${params?.value ? params.value.toUpperCase() : '-'}`
                // }
            },
            {
                field: `name`,
                headerName: t("name"),
                headerAlign: 'left',
                align: 'left',
                // headerClassName: 'my-super-theme--naming-group',
                width: 400,
                // renderCell: (params) => {
                //     // console.log('params', params)
                //     return `${params?.value ? params.value.toUpperCase() : '-'}`
                // }
            },
            {
                field: `code`,
                headerName: t("code"),
                headerAlign: 'left',
                align: 'left',
                // headerClassName: 'my-super-theme--naming-group',
                width: 150,
                // renderCell: (params) => {
                //     // console.log('params', params)
                //     return `${params?.value ? params.value.toUpperCase() : '-'}`
                // }
            },
            {
                field: `model`,
                headerName: t("model"),
                headerAlign: 'left',
                align: 'left',
                // headerClassName: 'my-super-theme--naming-group',
                width: 170,
                // renderCell: (params) => {
                //     // console.log('params', params)
                //     return `${params?.value ? params.value.toUpperCase() : '-'}`
                // }
            },
            // {
            //     field: `description`,
            //     headerName: t("description"),
            //     headerAlign: 'left',
            //     align: 'left',
            //     // headerClassName: 'my-super-theme--naming-group',
            //     width: 300,
            //     // renderCell: (params) => {
            //     //     // console.log('params', params)
            //     //     return `${params?.value ? params.value.toUpperCase() : '-'}`
            //     // }
            // },
            {
                field: `qty`,
                headerName: t("stockTakeQty"),
                headerAlign: 'right',
                align: 'right',
                // headerClassName: 'my-super-theme--naming-group',
                headerClassName: 'super-app-theme--header',
                cellClassName: 'super-app-theme--cell',
                width: 160,
                // renderCell: (params) => {
                //     // console.log('params', params)
                //     return `${params?.value ? params.value.toUpperCase() : '-'}`
                // }
                type: 'number',
                editable: true,
            },
            {
                field: `uomName`,
                headerName: t("uomName"),
                headerAlign: 'left',
                align: 'left',
                // headerClassName: 'my-super-theme--naming-group',
                width: 100,
                // renderCell: (params) => {
                //     // console.log('params', params)
                //     return `${params?.value ? params.value.toUpperCase() : '-'}`
                // }
            },
            {
                field: `uomId`,
                headerName: t("uomId"),
                headerAlign: 'left',
                align: 'left',
                // headerClassName: 'my-super-theme--naming-group',
                width: 80,
                // renderCell: (params) => {
                //     // console.log('params', params)
                //     return `${params?.value ? params.value.toUpperCase() : '-'}`
                // }
            },

        ]
    }

    const getBreadcumbActionMenus = () => {

        let props = []

        // if (isPermissionAllow({ functionType: functionTypes.pageNew.id })) {
        //     props.push({
        //         displayText: "Load From ...",
        //         onClick: () => {

        //             // check the location is selected - valid
        //             if (validateLocationSelection() === false) {
        //                 promptMessage(false, t(`pleaseSelectAnyLocation`))
        //                 return false;
        //             }

        //             setLoadDocumentConfig(prev => ({ ...prev, show: true }))

        //             return true;

        //         }
        //     })
        // }

        return props
    }

    // const validateLocationSelection = () => {
    //     // return (selectLocationIds && selectLocationIds.length === 1)
    //     const selected = getLocationIds()
    //     // console.log('selected', selected)
    //     return selected && selected.length === 1
    // }

    const generateExcelDownload = ({ allData = [] }) => {

        let excelHeader = [Object.keys(_excelHeaders).map(i => _excelHeaders[i].display)]

        let excelData = []

        // console.log('dataDownloadInventory', dataDownloadInventory)

        allData.forEach((i, index) => {
            excelData.push([
                (index + 1),
                i?.id,
                i?.item_name,
                i?.code,
                i?.model,
                i?.uom_id,
                i?.uom_name,
                i?.total_remain_qty,
                i?.pending_inbound_qty,
                i?.transfer_in_transit_qty,
                ""
            ])
        })

        let rawLines = [...excelHeader, ...excelData]

        console.log('_data', rawLines)

        /* create worksheet */
        let ws = XLSX.utils.aoa_to_sheet(rawLines);
        /* create workbook and export */
        let wb = XLSX.utils.book_new();

        // ws["!merges"] = merges
        // ws["!cols"] = getColsDefault()

        XLSX.utils.book_append_sheet(wb, ws, "Sheet1");

        const downloadFileName = `StockTakeFullInv-${dayjs().format("YYYYMMDDHHmmss")}.xlsx`

        XLSX.writeFile(wb, `${downloadFileName}`);

        setLoaderOpen(false)
        promptMessage(true, `Import dataset format downloaded (Full Inventories)`)

    }

    const handleDownloadDataset = () => {
        fetchAllInventories({ locationIds: [values.locationId] })
    }

    const handleFileUpload = (e) => {

        const file = e.target.files[0];

        if (!file) return false;

        // assignExcelReader(file)

        // console.log('file', file)

        let reader = new FileReader();

        reader.readAsArrayBuffer(file);

        reader.onload = async function (e) {

            let data = new Uint8Array(reader.result);
            let workbook = XLSX.read(data, { type: 'array' });
            // const base64Data = XLSX.write(workbook, { bookType: "xlsx", type: "base64" });

            // console.log('base64Data', base64Data)
            // console.log('workbook', workbook)

            let results = []

            workbook.SheetNames.forEach((e1, index1) => {

                let ws = workbook.Sheets[e1]; // get the first worksheet
                let jsonDataRows = XLSX.utils.sheet_to_json(ws, { header: 1, blankrows: false })
                // console.log(`json ${index1}`, JSON.stringify(jsonDataRows))

                // console.log(`jsonDataRows - ${index1}`, jsonDataRows)

                jsonDataRows.forEach((i1, index1) => {
                    if (index1 > 0) {

                        // check the stockTakeQty - default to 0
                        let _stockTakeQty = i1[_excelHeaders.stockTakeQty.indexNo]

                        // console.log('_stockTakeQty', _stockTakeQty)

                        if (_stockTakeQty === "") _stockTakeQty = 0

                        results.push({
                            [`${_excelHeaders.no.id}`]: i1[_excelHeaders.no.indexNo],
                            [`${_excelHeaders.itemId.id}`]: i1[_excelHeaders.itemId.indexNo],
                            [`${_excelHeaders.itemName.id}`]: i1[_excelHeaders.itemName.indexNo],
                            [`${_excelHeaders.model.id}`]: i1[_excelHeaders.model.indexNo],
                            [`${_excelHeaders.uomId.id}`]: i1[_excelHeaders.uomId.indexNo],
                            [`${_excelHeaders.uom.id}`]: i1[_excelHeaders.uom.indexNo],
                            [`${_excelHeaders.code.id}`]: i1[_excelHeaders.code.indexNo],
                            [`${_excelHeaders.pendingInboundQty.id}`]: i1[_excelHeaders.pendingInboundQty.indexNo],
                            [`${_excelHeaders.inStockQty.id}`]: i1[_excelHeaders.inStockQty.indexNo],
                            [`${_excelHeaders.transferInTransitQty.id}`]: i1[_excelHeaders.transferInTransitQty.indexNo],
                            [`${_excelHeaders.stockTakeQty.id}`]: _stockTakeQty,
                        })

                    }
                })

            })

            // check the max allowed rows
            // let _rows = []
            let _rows = values.rows
            let currentRowsCount = values.rows.length
            let k = 1
            let successCount = 0
            let skipCount = 0

            results.forEach((i, index) => {

                if ((currentRowsCount + k) <= _maxRowsAllowed) {
                    // _rows.push({
                    //     ...initialRowValues,
                    //     no: (index + 1),
                    //     itemId: i?.itemId,
                    //     name: i?.itemName,
                    //     description: `${i?.itemName} (${i?.code})`,
                    //     code: i?.code,
                    //     uomId: i?.uomId,
                    //     uomName: i?.uom,
                    //     decription: `-`,
                    //     qty: i?.stockTakeQty
                    // })
                    _rows = [..._rows, ...[
                        {
                            ...initialRowValues,
                            docItemId: 0,
                            no: (index + 1),
                            itemId: i?.itemId,
                            name: i?.itemName,
                            description: `${i?.itemName} (${i?.code})`,
                            code: i?.code,
                            uomId: i?.uomId,
                            uomName: i?.uom,
                            decription: `-`,
                            qty: i?.stockTakeQty
                        }
                    ]]
                    successCount += 1
                    k += 1
                } else {
                    skipCount += 1
                }

            })

            // console.log('results', results, _rows)

            setFieldValue(`rows`, _rows)

            if (skipCount > 0) {
                promptMessage(
                    false,
                    `${skipCount} ${t("rowsSkipped")} (${t("maxRowsAllowed")}: ${_maxRowsAllowed})`,
                    {
                        warning: [{
                            title: `{Read ${t("totalImportRows")}: ${results.length}}`,
                            message: `${successCount} Imported / ${skipCount} Skipped`
                        }]
                    }
                )
            }


        }

        return true

    }

    const handleSearchItem = () => {
        setSearchOpen(true)
    }

    return (
        <Box>
            {
                getHtmlHead({ routeType, title: headTitles.newStockTake })
            }

            <CommonBreadcumbs
                routeType={routeType}
                pageTitle={t("updateStockTake")}
                breadcrumbs={[
                    {
                        displayText: t("stockTakes"),
                        props: {
                            href: getRoute('documents/stockTakes')
                        }
                    },
                    {
                        displayText: t("updateStockTake"),
                        props: {
                            color: 'secondary.main',
                        }
                    },
                ]}
            />


            {
                isPermissionAllow({ functionType: functionTypes.pageNew.id }) ?
                    <RenderAll
                        t={t}
                        datagridRef={datagridRef}
                        formik={formik}
                        selectedIds={selectedIds}
                        dataInventory={dataInventory}
                        datagridColumns={getDatagridColumns()}
                        availableLocations={availableLocations}
                        // allowMainForm={validateLocationSelection()}
                        handleSearchItem={handleSearchItem}
                        handleLocationOnNext={({ selected }) => {

                            // console.log('selected', selected)

                            setLocationIds([selected[0].id])
                            setFieldValue(`locationId`, selected[0].id)
                            setFieldValue(`locationName`, selected[0].location_name)

                        }}
                        handleResetLocation={() => {
                            setLocationIds([])
                        }}
                        handleDownloadDataset={handleDownloadDataset}
                        handleFileUpload={handleFileUpload}
                        onCellEditStop={(params, event) => {

                            setTimeout(() => {
                                // console.log('params', params, params.id, datagridRef)
                                let newValue = datagridRef?.current?.getCellValue(params.id, `qty`)
                                // let b = datagridRef?.current?.getRow(params.id)
                                // console.log('a', a, b)

                                let a = []

                                values.rows.forEach(i => {
                                    if (params.id === i.itemId) {
                                        i.qty = newValue
                                    }
                                    a.push(i)
                                })

                                setFieldValue(`rows`, a)

                            }, 500)


                            if (params.reason === GridCellEditStopReasons.cellFocusOut) {
                                event.defaultMuiPrevented = true;
                            }
                        }}
                        handleRowSelectionModelChange={(ids) => {
                            const selectedIDs = new Set(ids);
                            const selectedRowData = values.rows.filter((row) => selectedIDs.has(row.itemId.toString()))
                            const selectedIds = selectedRowData.map(i => i.itemId)
                            // console.log(selectedRowData, selectedIds);
                            setSelectedIds(selectedIds)

                        }}
                        handleRemoveRows={({ selectedIds }) => {

                            let _rows = values.rows.filter(i => selectedIds.includes(i.itemId) === false)
                            setFieldValue(`rows`, _rows)

                            promptMessage(true, `${selectedIds.length} ${t("selectedRowsRemoved")}`)

                        }}
                    />
                    :
                    <CommonRestricted />
            }

            {/* {
                loadDocumentConfig?.show &&

                <LoadFromDocuments
                    fromDocumentId={loadDocumentConfig?.documentId}
                    fromDocumentType={loadDocumentConfig?.documentType}
                    show={loadDocumentConfig?.show}
                    filledSearchKeyword={loadDocumentConfig?.keyword}
                    handleOnCancel={() => {
                        setLoadDocumentConfig(prev => ({ ...prev, show: false }))
                    }}
                    handleOnSelect={(props) => {

                        setLoadDocumentConfig(prev => ({ ...prev, show: false }))

                        // load the data into the state
                        updateStateFromSearchDocument(props)

                    }}
                />
            } */}

            {/* {JSON.stringify(values.rows)} */}

            <RenderCommonLoader
                loaderOpen={loaderOpen}
                handleCloseLoader={handleCloseLoader}
                title={`Consolidate Available Product Items`}
                dataDownloadInventory={dataDownloadInventory}
                dataDownloadInventoryCount={dataDownloadInventoryCount}
            />
            <SearchItems
                // id={`rows.name`}
                open={Boolean(searchOpen)}
                handleOnExit={() => setSearchOpen(false)}
                skipSearchInput
                // handleOnCancel={() => { }}
                // handleOnSearchChange={(event) => {
                //     // setFieldValue(`rows.${index}.name`, `${event.target.value}`)
                // }}
                handleOnSelect={({ id, item }) => {
                    // console.log('id', id, item)

                    let currentRows = values?.rows ? values.rows : []
                    let nextNo = currentRows.length === 0 ? 1 : parseInt(currentRows[currentRows.length - 1].no, 10) + 1

                    // console.log('currentRows.length', currentRows.length, _maxRowsAllowed)

                    if (currentRows.length >= _maxRowsAllowed) {
                        promptMessage(false, `${t("reachMaxRowsAllowed")}`)
                        return false;
                    }

                    // validate the current rows do not have this id
                    let filter = currentRows.filter(i => i.itemId === id)

                    if (filter.length > 0) {
                        promptMessage(false, `${t("itemExistInListing")}`)
                        return false;
                    }

                    let aaa = {
                        ...initialRowValues,
                        docItemId: 0,
                        no: (nextNo),
                        itemId: item?.id,
                        name: item?.item_name,
                        description: `${item?.item_name} (${item?.code})`,
                        code: item?.code,
                        uomId: item?.uom_id,
                        uomName: item?.uom_name,
                        decription: `-`,
                        qty: 0
                    }

                    // console.log('currentRows', currentRows, aaa)

                    currentRows = [...currentRows, ...[aaa]]

                    setFieldValue(`rows`, currentRows)

                    return true

                }}
                textProps={{
                    // disabled: true,
                    // value: itemValues?.name ? itemValues.name : "",
                    // error: Boolean(itemErrors?.name),
                    // helperText: itemErrors?.name
                }}
            />

        </Box>
    )
}